import { formatDay } from '../../i18n';

/** #615 — the dates on one line, for paper: "10 Oct 2026",
 *  "03 Apr – 04 Apr 2027", "28 Dec 2026 – 02 Jan 2027". */
export function tournamentDatesLine(start: string, end?: string | null): string {
  const first = String(start).slice(0, 10);
  const last = end ? String(end).slice(0, 10) : first;
  if (last === first) return formatDay(first, 'dd MMM yyyy');
  if (first.slice(0, 4) === last.slice(0, 4)) return `${formatDay(first, 'dd MMM')} – ${formatDay(last, 'dd MMM yyyy')}`;
  return `${formatDay(first, 'dd MMM yyyy')} – ${formatDay(last, 'dd MMM yyyy')}`;
}

/** #615 — the dates of a tournament: a column at the right of the name, on
 *  the tournament card and in the header of the tournament page. Line 1, in
 *  bold: the days. Line 2, in small grey text: the year. On a phone the end
 *  day goes to its own line. `date_start` and `date_end` are calendar dates
 *  (`YYYY-MM-DD`, #410): the year comes from the string, not from a Date. */
export default function TournamentDates({ start, end, isToday = false, testId, className = '' }: {
  start: string;
  end?: string | null;
  /** A tournament of today: green days. */
  isToday?: boolean;
  testId?: string;
  className?: string;
}) {
  const first = String(start).slice(0, 10);
  const last = end ? String(end).slice(0, 10) : first;
  const startYear = first.slice(0, 4);
  const endYear = last.slice(0, 4);
  return (
    <div data-testid={testId} className={`text-right shrink-0 ${className}`}>
      <div className={`text-sm font-semibold whitespace-nowrap ${isToday ? 'text-green-700' : ''}`}>
        {formatDay(first, 'dd MMM')}
        {last !== first && <span className="block sm:inline">{' – '}{formatDay(last, 'dd MMM')}</span>}
      </div>
      <div className="text-xs text-gray-400 whitespace-nowrap">
        {startYear === endYear ? startYear : `${startYear} – ${endYear}`}
      </div>
    </div>
  );
}
